import {
  WorkflowStepType,
  type WorkflowConfig,
  type WorkflowConfigStepType,
  type WorkflowSystemActionType,
  type WorkflowUserTaskType,
} from "@validereinc/domain";

export function flattenWorkflowSteps(
  steps?: WorkflowConfig["steps"]
): Record<string, WorkflowSystemActionType | WorkflowUserTaskType> {
  const flattenedSteps: Record<
    string,
    WorkflowSystemActionType | WorkflowUserTaskType
  > = {};
  if (!steps) return flattenedSteps;
  for (const [id, step] of Object.entries(steps)) {
    if (step.type === WorkflowStepType.PARALLEL) {
      for (const branch of step.branches) {
        Object.assign(flattenedSteps, flattenWorkflowSteps(branch.steps));
      }
    } else {
      flattenedSteps[id] = step;
    }
  }
  return flattenedSteps;
}

export function getAllWorkflowSteps(
  steps?: WorkflowConfig["steps"]
): Record<string, WorkflowConfigStepType> {
  const allWorkflowSteps: Record<string, WorkflowConfigStepType> = {};
  if (!steps) return allWorkflowSteps;

  for (const [id, step] of Object.entries(steps)) {
    allWorkflowSteps[id] = step;
    if (step.type === WorkflowStepType.PARALLEL) {
      for (const branch of step.branches) {
        Object.assign(allWorkflowSteps, getAllWorkflowSteps(branch.steps));
      }
    }
  }
  return allWorkflowSteps;
}
